import { Dropdown, MenuProps } from "antd";
import { useTranslation } from "react-i18next"
import { CheckCircleFilled, CloseCircleFilled, FilePdfFilled, HistoryOutlined, MailFilled, PrinterFilled, SearchOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { MenuInfo } from "rc-menu/lib/interface";

export type ReservationContextMenuProps = {
    isOpen?: boolean;
    position?: ContextMenuPosition;
    onContextMenuItemClick?: (menuKeyId?: string) => void;
}

export type ContextMenuPosition = {
    x?: number;
    y?: number;
}

export const KEY_MONITOR_CONFIRM: string = "1";
export const KEY_MONITOR_NOT_CONFIRM: string = "2";
export const KEY_MONITOR_DETAIL: string = "3";
export const KEY_MONITOR_PDF: string = "4";
export const KEY_MONITOR_PDF_LIST: string = "5";
export const KEY_MONITOR_PRINT: string = "6";
export const KEY_MONITOR_EMAIL: string = "7";
export const KEY_MONITOR_HISTORY: string = "8";

const disableReservationOperations = process.env.REACT_APP_DISABLE_RESERVATION_OPERATIONS === "true";

export const ReservationContextMenu = (props: ReservationContextMenuProps) => {
    const { t } = useTranslation();

    const dispatchContextMenuItemClick = (e: MenuInfo) => {
        if (props.onContextMenuItemClick) {
            props.onContextMenuItemClick(e?.key);
        }
    }

    const items: MenuProps["items"] = disableReservationOperations
        ?
        [           
            {
                key: KEY_MONITOR_DETAIL,
                label: t("monitor.contextMenu.detail"),
                icon: <SearchOutlined color="yellow" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PDF,
                label: t("monitor.contextMenu.pdf"),
                icon: <FilePdfFilled color="magenta" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PDF_LIST,
                label: t("monitor.contextMenu.pdfList"),
                icon: <UnorderedListOutlined color="magenta" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PRINT,
                label: t("monitor.contextMenu.print"),
                icon: <PrinterFilled />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_EMAIL,
                label: t("monitor.contextMenu.email"),
                icon: <MailFilled />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_HISTORY,
                label: t("monitor.contextMenu.history"),
                icon: <HistoryOutlined />,
                onClick: dispatchContextMenuItemClick
            },
        ]
        :
        [
            {
                key: KEY_MONITOR_CONFIRM,
                label: t("monitor.contextMenu.confirm"),
                icon: <CheckCircleFilled color="green" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_NOT_CONFIRM,
                label: t("monitor.contextMenu.notConfirm"),
                icon: <CloseCircleFilled color="red" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_DETAIL,
                label: t("monitor.contextMenu.detail"),
                icon: <SearchOutlined color="yellow" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PDF,
                label: t("monitor.contextMenu.pdf"),
                icon: <FilePdfFilled color="magenta" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PDF_LIST,
                label: t("monitor.contextMenu.pdfList"),
                icon: <UnorderedListOutlined color="magenta" />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_PRINT,
                label: t("monitor.contextMenu.print"),
                icon: <PrinterFilled />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_EMAIL,
                label: t("monitor.contextMenu.email"),
                icon: <MailFilled />,
                onClick: dispatchContextMenuItemClick
            },
            {
                key: KEY_MONITOR_HISTORY,
                label: t("monitor.contextMenu.history"),
                icon: <HistoryOutlined />,
                onClick: dispatchContextMenuItemClick
            },
        ];

    return (
        <Dropdown
            menu={{ items }}
            open={props.isOpen}
            overlayStyle={{ left: `${props.position?.x}px`, top: `${props.position?.y}px` }}
        >
            <></>
        </Dropdown>
    )
}